// extracted by mini-css-extract-plugin
export default {"built":"Built_built__Biu8P","h2":"Built_h2__Mn1OM","p":"Built_p__pIxUK"};